import React, { useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';

function McpHeader({ title }) {
  const { currentUser, logout } = useContext(AuthContext);
  const userName = currentUser?.name || currentUser?.full_name || currentUser?.email?.split('@')[0] || 'User';

  return (
    <>
      <div className="flex items-center justify-between px-8 py-4">
        <h1 className="font-display text-2xl font-bold text-ink">{title}</h1>
        <div className="flex items-center gap-3">
          <span className="text-sm font-semibold text-ink-100">{userName}</span>
          <div className="h-4 w-px bg-paper-300" />
          <button
            type="button"
            onClick={logout}
            className="inline-flex items-center gap-1.5 rounded-full border-2 border-paper-300 bg-white px-3.5 py-1.5 text-sm font-bold text-ink transition hover:bg-paper-100"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <polyline points="16 17 21 12 16 7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
            Sign out
          </button>
        </div>
      </div>
      <div className="h-px w-full bg-paper-300" />
    </>
  );
}

export default McpHeader;
